import { FilterItem } from 'components/multi-filter/multi-filter';
import { TableColumnProps } from '../../components/table/table-component/table-component';

export const tableStructure: TableColumnProps[] = [
  {
    id: 'source',
    title: 'Source',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'description',
    title: 'Description',
    position: 'left',
    withSort: true,
    noFilters: true,
    withSearch: true,
  },
  {
    id: 'owner',
    title: 'Organization',
    position: 'left',
    withSort: true,
    noFilters: true,
    withSearch: true,
  },
  {
    id: 'repository',
    title: 'Repository',
    position: 'left',
    withSort: true,
    noFilters: true,
    withSearch: true,
  },
  {
    id: 'author_email',
    title: 'User',
    position: 'left',
    withSort: true,
    noFilters: true,
    withSearch: true,
  },
  {
    id: 'severity',
    title: 'Severity',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'state',
    title: 'State',
    position: 'left',
    withSort: true,
  },
  {
    id: 'file',
    title: 'File',
    position: 'left',
    withSort: true,
    noFilters: true,
    withSearch: true,
  },
  {
    id: 'updated_at',
    title: 'Updated',
    position: 'left',
    isDate: true,
    withSort: true,
    noFilters: true,
  },
];

export const SastFilterList: FilterItem[] = [
  {
    title: 'State',
    filterId: 'state',
    filterColumns: ['state'],
    props: [
      {
        label: 'Dismissed',
        value: 'dismissed',
      },
      {
        label: 'Open',
        value: 'open',
      },
    ],
  },
];
